import request from '@/utils/request'

// 迁移Pending状态订单
export const migrateOrder = (data: any) =>
  request({
    url: '/manage/withdraw-order/migrate',
    method: 'patch',
    data
  })

// 请求日志
export const getRequestLog = (params: any) =>
  request({
    url: '/manage/gateway-api-log',
    method: 'get',
    params
  })

// 踢出队列
export const inKickOut = (data: any) =>
  request({
    url: `/manage/kick-out`,
    method: 'post',
    data
  })

// 退款订单
export const refundList = (params: any) =>
  request({
    url: '/manage/refund-order',
    method: 'get',
    params
  })

// 清除计数
export const removeCount = (data: any) =>
  request({
    url: '/manage/remove-refund-notify',
    method: 'post',
    data
  })

// 请求日志已读操作
export const readRequestLog = (data: any) =>
  request({
    url: '/manage/update-api-logs-unread',
    method: 'post',
    data
  })
